import {all} from "redux-saga/effects";
import steps from "./entities/saga";

export const rootSaga = function* root() {
  yield all([steps()]);
};
